import {RadioGroup, RadioGroupItem} from 'src/components/radio-group'
import {Skeleton} from 'src/components/skeleton'
import {Switch} from 'src/components/switch'
import {cn} from 'src/layouts/main-layout/app-sidebar/utils/utils'
import {useCompaniesSelector} from 'src/layouts/main-layout/companies-selector/companies-selector-context'
import {CompaniesSelectorScrollText} from 'src/layouts/main-layout/companies-selector/companies-selector-scroll-text'

export function CompaniesSelectorList() {
  const {activeTab, search, handleSetSelectedCompanies, selectedCompanies, queryCompanies} = useCompaniesSelector()
  const {data: companies, isLoading} = queryCompanies

  if (isLoading) {
    return (
      <div className='flex flex-col gap-2 p-3'>
        {Array.from({length: 3}).map((_, i) => (
          <Skeleton key={i} className='h-8 w-full' />
        ))}
      </div>
    )
  }

  const filtered = companies?.filter((company) => company.name.toLowerCase().includes(search?.toLowerCase() ?? ''))

  return (
    <div className='flex h-40 flex-col gap-3 overflow-y-auto p-3 pt-0'>
      {activeTab === 'switch' &&
        filtered?.map((company) => (
          <div key={company.id} className='flex items-center gap-3 rounded-md py-1 pl-1 hover:bg-[#46556966]'>
            <Switch
              className='data-[state=checked]:bg-white data-[state=unchecked]:bg-[#465569]'
              thumbClassName='bg-secondary'
              checked={selectedCompanies.some((it) => it.id === company.id)}
              onCheckedChange={() => handleSetSelectedCompanies(company)}
            />
            <CompaniesSelectorScrollText text={company.name} className='text-sidebar-foreground text-sm' onClick={() => handleSetSelectedCompanies(company)} />
          </div>
        ))}

      {activeTab === 'radio' && (
        <RadioGroup
          value={selectedCompanies[0]?.id?.toString()}
          onValueChange={(value) => {
            const company = filtered?.find((c) => c.id.toString() === value)
            if (company) handleSetSelectedCompanies(company, true)
          }}>
          {filtered?.map((company) => {
            const isExtraSelected = selectedCompanies.slice(1).some((c) => c.id === company.id)

            return (
              <div
                key={company.id}
                className={cn(
                  'flex h-7 items-center gap-3 overflow-hidden rounded-md pl-1 transition-colors hover:bg-[#46556966]',
                  isExtraSelected && 'animate-blink-once bg-[#46556966]',
                )}>
                <RadioGroupItem value={company.id.toString()} id={`company-${company.id}`} />
                <CompaniesSelectorScrollText
                  text={company.name}
                  className='text-sidebar-foreground min-w-0 flex-1 text-sm'
                  onClick={() => handleSetSelectedCompanies(company, true)}
                />
              </div>
            )
          })}
        </RadioGroup>
      )}
    </div>
  )
}
